"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlInformationForm = void 0;
var React = require("react");
var mobx_react_1 = require("mobx-react");
var buttons_1 = require("../buttons");
var datepicker_1 = require("../datepicker");
var moment = require("moment");
var App_1 = require("../../App");
var combobox_1 = require("../lib/combobox");
var controlUserDefinedFields_1 = require("./controlUserDefinedFields");
var config_1 = require("../../config");
var ControlInformationForm = (function (_super) {
    __extends(ControlInformationForm, _super);
    function ControlInformationForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ControlInformationForm.prototype.handleFormEvent = function (event) {
        var target = event.target;
        var value = target.type === 'checkbox' ? target.checked : target.value;
        var name = target.name;
        this.props.onChange(name, value);
    };
    ControlInformationForm.prototype.handleValueChange = function (name, value) {
        this.props.onChange(name, value);
    };
    ControlInformationForm.prototype.handleSubmit = function () {
        this.props.handleSubmit();
    };
    ControlInformationForm.prototype.handleSubmitAndClose = function () {
        this.props.handleSubmitAndClose();
    };
    ControlInformationForm.prototype._quickAddUser = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, App_1.store.quickAddUser(value)];
                    case 1:
                        user = _a.sent();
                        this.handleValueChange("assigned_to", user.id.toString());
                        return [2];
                }
            });
        });
    };
    ControlInformationForm.prototype.quickAddUser = function (value) {
        this._quickAddUser(value);
    };
    ControlInformationForm.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var recurrenceIsOn = props.recurrence !== null;
        var statusChoices = props.availableStatuses.map(function (choice) {
            return React.createElement("option", { key: choice.value, value: choice.value }, choice.display_name);
        });
        var assignedToChoices = props.availableOwners.map(function (choice) {
            return {
                label: choice.display_name.split(" (")[0],
                suggestionLabel: choice.display_name,
                value: choice.value
            };
        });
        var assignedTo = props.controlPut.assigned_to;
        var deadlineMoment = props.controlPut.deadline ? moment(props.controlPut.deadline) : null;
        return (React.createElement("div", { className: "ControlInformationForm" },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-6" },
                    React.createElement("textarea", { className: "form-control ControlInformationForm__Description", name: "description", value: props.controlPut.description, onChange: this.handleFormEvent.bind(this) })),
                React.createElement("div", { className: "col-6" },
                    React.createElement("div", { className: "form-group row" },
                        React.createElement("div", { className: "col-4" },
                            React.createElement("label", { htmlFor: "status_id" }, gettext("Status"))),
                        React.createElement("div", { className: "col-8" },
                            React.createElement("select", { name: "status", className: "form-control", value: props.controlPut.status, onChange: function (e) { return _this.handleValueChange("status", parseInt(e.target.value)); } }, statusChoices))),
                    React.createElement("div", { className: "form-group row" },
                        React.createElement("div", { className: "col-4" },
                            React.createElement("label", { htmlFor: "owner_id" }, gettext("Owner"))),
                        React.createElement("div", { className: "col-8" },
                            React.createElement(combobox_1.InsertingComboBox, { createOption: true, className: "form-control", options: assignedToChoices, value: assignedTo ? assignedTo.toString() : null, onChange: function (value) { return _this.handleValueChange("assigned_to", value ? parseInt(value) : null); }, insertInstruction: this.quickAddUser.bind(this), confirmationText: function (value) { return gettext("Quick add for") + " ".concat(value); } }))),
                    React.createElement("div", { className: "form-group row" },
                        React.createElement("div", { className: "col-4" },
                            React.createElement("label", { htmlFor: "deadline_id" }, gettext("Deadline"))),
                        React.createElement("div", { className: "col-8" }, recurrenceIsOn ?
                            React.createElement("span", null, props.controlPut.deadline)
                            :
                                React.createElement(datepicker_1.default, { name: "deadline", selected: deadlineMoment, onChange: function (date) { return _this.handleValueChange("deadline", date ? date.format(config_1.ISO_DATE_FORMAT) : null); } }))),
                    recurrenceIsOn &&
                        React.createElement("div", { className: "form-group row" },
                            React.createElement("div", { className: "col-4" }, gettext("Next deadline")),
                            React.createElement("div", { className: "col-8" },
                                props.recurrence.next_date,
                                React.createElement("br", null),
                                "(",
                                props.recurrence.repr,
                                ")")))),
            props.udf_types.length > 0 &&
                React.createElement(React.Fragment, null,
                    React.createElement("h5", null, props.udf_section_header || gettext("User defined fields")),
                    React.createElement(controlUserDefinedFields_1.ControlUserDefinedFields, { udf_types: props.udf_types, udf_values: props.controlPut.udf_values, target_object_id: props.controlPut.id, onChange: props.onChange })),
            React.createElement("div", { className: "d-flex float-right" },
                React.createElement(buttons_1.OutlineButton, { onClick: this.handleSubmitAndClose.bind(this), disabled: props.updating }, gettext("Save and close")),
                React.createElement("div", null),
                React.createElement(buttons_1.PrimaryButton, { onClick: this.handleSubmit.bind(this), disabled: props.updating }, gettext("Save")))));
    };
    ControlInformationForm = __decorate([
        mobx_react_1.observer
    ], ControlInformationForm);
    return ControlInformationForm;
}(React.Component));
exports.ControlInformationForm = ControlInformationForm;
